
jQuery(document).ready(function($){
  if(window.innerWidth < 990){
    $('.big-megamenu ul.nav li.elementkit-nav-item').first().addClass('show');
    $('.elementkit-tab-content > *').first().addClass('show');
    
    $('li.elementkit-nav-item').removeClass('show');
    $('.big-megamenu ul.nav li.elementkit-nav-item').on('click', function(e){
      e.preventDefault();

      var index = $(this).index();

      // Remove .show from all top li and add to clicked
      // $('.big-megamenu ul.nav li.elementkit-nav-item').removeClass('show');
      this.classList.toggle('show');

      $('.elementkit-tab-content > *').removeClass('show');
      $('.elementkit-tab-content > *').eq(index).addClass('show');
    });
  }
});

document.querySelectorAll('details').forEach(detail => {
  const svg = detail.querySelector('#menu-drawer summary svg');
  if (!svg) return;
  
  svg.style.transition = 'transform 0.3s ease';
  svg.style.transformOrigin = 'center';

  let initialized = false;
  detail.addEventListener('toggle', () => {
    if (initialized) {
      svg.style.transform = detail.open ? 'rotate(180deg)' : 'rotate(0deg)';
    }
    initialized = true;
  });
});



